import React, {useEffect} from 'react';
import Picture from "../../Picture/components/Picture";
import CardLink from "./CardLink";
import styled from 'styled-components';
import Heading from "../../Typography/components/Heading";
import Title from "../../Typography/components/Title";
import SearchIcon from "./DataCard/SearchIcon";
import {useInView} from "react-intersection-observer";
import anime from "animejs";

const StyledCardLink = styled(CardLink)`
  display: block;
`;
const Tag = styled(Heading)`
  font-size: 0.75rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 1.5rem 0 0;
`;
const StyledTitle = styled(Title)`
  display: block;
  font-size: 1.7rem;
  font-weight: 700;
  color: #000;
  line-height: 2.25rem;
  margin-bottom: 1rem;
`;
const StyledSearchIcon = styled(SearchIcon)``;
const Image = styled.div`
  display: inline-block;
  position: relative;
  overflow: hidden;
  opacity: 0;
  
  ::after {
    background: #000;
    content: "";
    display: block;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    transition: all .25s;
  }

  img {
    width: 100%;
    transition: all 0.25s ease-out;
    padding: 0;
    margin: 0;
  }
`;
const Link = styled.div`
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  line-height: 2rem;
  margin: 0 0 1rem;
  position: relative;
  text-transform: uppercase;
  z-index: 1;
  opacity: 0;
`;
const Data = styled.div`
  margin-bottom: 2rem;

  ${Link} {
    position: relative;
    overflow: hidden;
    display: inline-block;

    ::after {
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      padding-top: 0.1rem;
      background: #635bff;
      position: absolute;
      left: -2px;
      bottom: 0;
      transform: translate3d(-100%, 0, 0);
      transition: transform .2s ease-out;
    }
  }
  
  &:hover {
    ${Link} {
      ::after {
        left: 0;
        transform: translate3d(0, 0, 0);
      }
    }
    
    
    ${Image} {
      ::after {
        opacity: 0.5;
      }
    
      img {
        transform: scale(1.2);
      }
      
      ${StyledSearchIcon} {
        opacity: 1;
      }
    }
  }
`;

const DataCard = ({className, path, title, defaultSource, sources, tag, linkTitle, hideTag = false, hideLink = false}) => {
  const [imageRef, imageInView, imageEntry] = useInView({
    triggerOnce: true
  });
  const [linkRef, linkInView, linkEntry] = useInView({
    triggerOnce: true
  });

  // image animation
  useEffect(() => {
    if (imageInView) {
      anime({
        targets: imageEntry && imageEntry.target,
        // translateY: [32, 0],
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1000,
        delay: 250,
      });
    }

    return () => {
      anime({
        targets: imageEntry && imageEntry.target,
        // translateY: [0, 32],
        opacity: [1, 0],
        easing: "easeOutExpo",
        duration: 100,
      });
    };
  }, [imageInView, imageEntry]);

  // link animation
  useEffect(() => {
    if (linkInView) {
      anime({
        targets: linkEntry && linkEntry.target,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1000,
        delay: 500,
      });
    }

    return () => {
      anime({
        targets: linkEntry && linkEntry.target,
        opacity: [1, 0],
        easing: "easeOutExpo",
        duration: 100,
      });
    };
  }, [linkInView, linkEntry]);

  return <StyledCardLink to={path} className={className}>
    <Data>
      <Image ref={imageRef}>
        <StyledSearchIcon />
        <Picture alt={title} defaultSource={defaultSource} sources={sources} />
      </Image>

      {!!!hideTag && <Tag level={6}>{tag}</Tag>}
      <StyledTitle level={5}>{title}</StyledTitle>
      {!!!hideLink && <Link ref={linkRef}>{linkTitle}</Link>}
    </Data>
  </StyledCardLink>
};

export default DataCard;